// import this after install `@mdi/font` package
import "@mdi/font/css/materialdesignicons.css";

import "vuetify/styles";
import { VDateInput } from "vuetify/labs/VDateInput";
import { createVuetify } from "vuetify";

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    components: {
      VDateInput,
    },
    locale: {
      locale: process.env.LOCALE,
    },
    date: {
      locale: {
        nl: "nl-NL",
        en: "en-GB",
      },
    },
    ssr: false,
    defaults: {
      global: {
        variant: "outlined",
      },
    },
  });
  app.vueApp.use(vuetify);
});
